export const GET_NOTICE = "GET_NOTICE";
export const UPDATE_NOTICE = "UPDATE_NOTICE";
